<template>
  <div>
    <Widget>
      <div style="background: #eaf0f6; border-radius: 0.5rem; padding: 1rem">
        <b-form>
          <div class="row">
            <div class="col-md-6 mb-3 d-flex align-items-center">
              <span class="fw-bold">
                Surat Permohonan Pengembalian/Perubahan
                <span class="text-danger">*</span>
              </span>
            </div>
            <div class="col-md-6 mb-3">
              <div class="row">
                <div class="col-6">
                  <b-form-file
                    id="file_permohonan_pemuktahiran"
                    v-model="form.file_permohonan_pemuktahiran"
                    plain
                    class="form-control"
                    name="Surat Permohonan"
                    accept=".pdf"
                    v-validate="
                      tmpFile.file_permohonan_pemuktahiran ? '' : 'required'
                    "
                    :style="{ opacity: isViewOnly ? 0.7 : 1 }"
                    :disabled="isViewOnly"
                  ></b-form-file>
                </div>
                <div class="col-6 d-flex">
                  <!-- <a class="btn btn-primary mr-2 text-white">
                    <i class="fa fa-cloud-upload" />
                    Unggah
                  </a> -->
                  <a
                    v-if="tmpFile.file_permohonan_pemuktahiran"
                    :href="tmpFile.file_permohonan_pemuktahiran"
                    target="_blank"
                    class="btn btn-success"
                  >
                    <i class="fa fa-download" />
                    Unduh
                  </a>
                </div>
              </div>
              <span class="text-danger" v-if="errors.has('Surat Permohonan')">
                {{ errors.first('Surat Permohonan') }}
              </span>
            </div>

            <div class="col-lg-4 mb-3">
              <label for="nomor_surat_permohonan">
                Nomor Surat <span class="text-danger">*</span>
              </label>
              <b-form-input
                id="nomor_surat_permohonan"
                v-model="form.nomor_surat_permohonan"
                v-validate="'required'"
                name="Nomor Surat"
                :style="{ opacity: isViewOnly ? 0.7 : 1 }"
                :disabled="isViewOnly"
              ></b-form-input>
              <span class="text-danger" v-if="errors.has('Nomor Surat')">
                {{ errors.first('Nomor Surat') }}
              </span>
            </div>
            <div class="col-lg-4 mb-3">
              <label for="perihal_surat_permohonan">
                Perihal Surat <span class="text-danger">*</span>
              </label>
              <b-form-input
                id="perihal_surat_permohonan"
                v-model="form.perihal_surat_permohonan"
                v-validate="'required'"
                name="Perihal Surat"
                :style="{ opacity: isViewOnly ? 0.7 : 1 }"
                :disabled="isViewOnly"
              ></b-form-input>
              <span class="text-danger" v-if="errors.has('Perihal Surat')">
                {{ errors.first('Perihal Surat') }}
              </span>
            </div>
            <div class="col-lg-4 mb-3">
              <label for="tanggal_surat_permohonan">
                Tanggal Surat <span class="text-danger">*</span>
              </label>
              <b-form-input
                type="date"
                id="tanggal_surat_permohonan"
                v-model="form.tanggal_surat_permohonan"
                v-validate="'required'"
                name="Tanggal Surat"
                :style="{ opacity: isViewOnly ? 0.7 : 1 }"
                :disabled="isViewOnly"
              ></b-form-input>
              <span class="text-danger" v-if="errors.has('Tanggal Surat')">
                {{ errors.first('Tanggal Surat') }}
              </span>
            </div>
          </div>
          <div class="mb-3" style="border-bottom: 1px solid black"></div>

          <div class="row mb-3">
            <div class="col-md-6 mb-3">
              <label for="jenis_pemuktahiran">
                Jenis Pemutakhiran <span class="text-danger">*</span>
              </label>
              <v-select
                id="jenis_pemuktahiran"
                v-model="form.jenis_pemuktahiran"
                :options="[
                  {
                    label: 'Pengembalian Seluruhnya/Pembatalan',
                    value: 'Pengembalian',
                  },
                  { label: 'Perubahan', value: 'Perubahan' },
                ]"
                :reduce="(data) => data.value"
                label="label"
                name="Jenis Pemutakhiran"
                v-validate="'required'"
                :style="{ opacity: isViewOnly ? 0.7 : 1 }"
                :disabled="isViewOnly"
              />
              <span class="text-danger" v-if="errors.has('Jenis Pemutakhiran')">
                {{ errors.first('Jenis Pemutakhiran') }}
              </span>
            </div>
            <div
              v-if="form.jenis_pemuktahiran === 'Perubahan'"
              class="col-md-6 mb-3"
            >
              <label for="jenis_permohonan_perubahan">
                Kategori Perubahan <span class="text-danger">*</span>
              </label>
              <v-select
                id="jenis_permohonan_perubahan"
                v-model="form.jenis_permohonan_perubahan"
                :options="[
                  'Kesalahan Redaksional',
                  'Fakta Baru',
                  'Kesalahan Konsiderans',
                  'Penambahan KBLI',
                  'Lainnya',
                ]"
                name="Kategori Perubahan"
                v-validate="'required'"
                :style="{ opacity: isViewOnly ? 0.7 : 1 }"
                :disabled="isViewOnly"
              />
              <span class="text-danger" v-if="errors.has('Kategori Perubahan')">
                {{ errors.first('Kategori Perubahan') }}
              </span>
            </div>
            <div class="w-100"></div>
            <div class="col-md-6 mb-3">
              <label for="jenis_permohonan">
                Jenis Permohonan <span class="text-danger">*</span>
              </label>
              <v-select
                id="jenis_permohonan"
                v-model="form.jenis_permohonan"
                :options="['Berusaha', 'Nonberusaha']"
                name="Jenis Permohonan"
                v-validate="'required'"
                :style="{ opacity: isViewOnly ? 0.7 : 1 }"
                :disabled="isViewOnly"
                @input="selectJenisKegiatan"
              />
              <span class="text-danger" v-if="errors.has('Jenis Permohonan')">
                {{ errors.first('Jenis Permohonan') }}
              </span>
            </div>
            <div class="col-md-6 mb-3">
              <label for="nomor_izin_terbit">
                Nomor Penerbitan Izin <span class="text-danger">*</span>
              </label>
              <i
                class="fa fa-info-circle ml-1"
                v-b-tooltip.hover.topright="
                  'Mohon input secara manual apabila Nomor Penerbitan Izin belum tersedia di dalam sistem'
                "
              />
              <div ref="dropdownNomorKkprl">
                <b-form-input
                  id="nomor_izin_terbit"
                  v-model="form.nomor_izin_terbit"
                  v-validate="'required'"
                  name="Nomor Penerbitan Izin"
                  :style="{ opacity: isViewOnly ? 0.7 : 1 }"
                  :disabled="isViewOnly"
                  @click="toggleOptionKkprl(!showOptionKkprl)"
                ></b-form-input>
                <div v-if="showOptionKkprl" style="position: relative">
                  <div class="option-kkprl-container">
                    <div
                      v-for="d in filteredNomorKkprl"
                      class="option-kkprl-item"
                      @click="
                        d.includes('Tidak ada pilihan') ||
                        d.includes('Pilih Jenis Permohonan')
                          ? undefined
                          : selectKkprl(d)
                      "
                    >
                      {{ d }}
                    </div>
                  </div>
                </div>
              </div>
              <span
                class="text-danger"
                v-if="errors.has('Nomor Penerbitan Izin')"
              >
                {{ errors.first('Nomor Penerbitan Izin') }}
              </span>
            </div>
            <div class="col-md-6 mb-3">
              <label for="instansi_pemohon">
                Instansi Pemohon <span class="text-danger">*</span>
              </label>
              <b-form-input
                id="instansi_pemohon"
                v-model="form.instansi_pemohon"
                v-validate="'required'"
                name="Instansi Pemohon"
                :style="{ opacity: isViewOnly ? 0.7 : 1 }"
                :disabled="isViewOnly"
              ></b-form-input>
              <span class="text-danger" v-if="errors.has('Instansi Pemohon')">
                {{ errors.first('Instansi Pemohon') }}
              </span>
            </div>
            <div
              v-if="form.jenis_permohonan === 'Berusaha'"
              class="col-md-6 mb-3"
            >
              <label for="nib">NIB <span class="text-danger">*</span></label>
              <b-form-input
                id="nib"
                v-model="form.nib"
                v-validate="'required'"
                name="NIB"
                :style="{ opacity: isViewOnly ? 0.7 : 1 }"
                :disabled="isViewOnly"
              ></b-form-input>
              <span class="text-danger" v-if="errors.has('NIB')">
                {{ errors.first('NIB') }}
              </span>
            </div>
            <div class="col-md-6 mb-3">
              <label for="nomor_permohonan">
                Nomor Permohonan <span class="text-danger">*</span>
              </label>
              <b-form-input
                id="nomor_permohonan"
                v-model="form.nomor_permohonan"
                v-validate="'required'"
                name="Nomor Permohonan"
                :style="{ opacity: isViewOnly ? 0.7 : 1 }"
                :disabled="isViewOnly"
              ></b-form-input>
              <span class="text-danger" v-if="errors.has('Nomor Permohonan')">
                {{ errors.first('Nomor Permohonan') }}
              </span>
            </div>
            <div class="col-md-6 mb-3">
              <label for="npwp">NPWP <span class="text-danger">*</span></label>
              <b-form-input
                id="npwp"
                v-model="form.npwp"
                v-mask="'##.###.###.#-###.####'"
                v-validate="'required'"
                name="NPWP"
                :style="{ opacity: isViewOnly ? 0.7 : 1 }"
                :disabled="isViewOnly"
              ></b-form-input>
              <span class="text-danger" v-if="errors.has('NPWP')">
                {{ errors.first('NPWP') }}
              </span>
            </div>
            <div class="col-md-6 mb-3">
              <label for="tanggal_penerbitan_izin">
                Tanggal Penerbitan <span class="text-danger">*</span>
              </label>
              <b-form-input
                type="date"
                id="tanggal_penerbitan_izin"
                v-model="form.tanggal_penerbitan_izin"
                v-validate="'required'"
                name="Tanggal Penerbitan"
                onfocus="this.showPicker()"
                :style="{ opacity: isViewOnly ? 0.7 : 1 }"
                :disabled="isViewOnly"
              ></b-form-input>
              <span class="text-danger" v-if="errors.has('Tanggal Penerbitan')">
                {{ errors.first('Tanggal Penerbitan') }}
              </span>
            </div>
            <div class="col-12 mb-3">
              <label for="alasan_pemuktahiran">
                Alasan Pemutakhiran <span class="text-danger">*</span>
              </label>
              <div :style="{ opacity: isViewOnly ? 0.7 : 1 }">
                <ckeditor
                  id="alasan_pemuktahiran"
                  v-model="form.alasan_pemuktahiran"
                  :editor="wygEditor"
                  :disabled="isViewOnly"
                ></ckeditor>
              </div>
              <span
                class="text-danger"
                v-if="errors.has('Alasan Pemutakhiran')"
              >
                {{ errors.first('Alasan Pemutakhiran') }}
              </span>
            </div>
          </div>

          <div class="row mb-3">
            <div class="col-md-6">
              <div class="d-flex justify-content-between align-items-center">
                <span class="fw-bold"> Dokumen Pendukung Lainnya </span>
              </div>
            </div>
            <div class="col-md-6">
              <div class="row">
                <div class="col-6">
                  <b-form-file
                    id="file_dokumen_pendukung"
                    v-model="form.file_dokumen_pendukung"
                    plain
                    class="form-control"
                    name="Surat Pengantar"
                    accept=".pdf"
                    :style="{ opacity: isViewOnly ? 0.7 : 1 }"
                    :disabled="isViewOnly"
                  ></b-form-file>
                </div>
                <div class="col-6 d-flex">
                  <!-- <a class="btn btn-primary mr-2 text-white">
                    <i class="fa fa-cloud-upload" />
                    Unggah
                  </a> -->
                  <a
                    v-if="tmpFile.file_dokumen_pendukung"
                    :href="tmpFile.file_dokumen_pendukung"
                    target="_blank"
                    class="btn btn-success"
                  >
                    <i class="fa fa-download" />
                    Unduh
                  </a>
                </div>
              </div>
            </div>
          </div>
          <legend><strong>Identitas Penanggung Jawab</strong></legend>
          <div class="row">
            <div class="col-md-6 mb-3">
              <label for="nama_penanggungjawab">
                Nama Penanggung Jawab <span class="text-danger">*</span>
              </label>
              <b-form-input
                id="nama_penanggungjawab"
                v-model="form.nama_penanggungjawab"
                v-validate="'required'"
                name="Nama Penanggung Jawab"
                :style="{ opacity: isViewOnly ? 0.7 : 1 }"
                :disabled="isViewOnly"
              ></b-form-input>
              <span
                class="text-danger"
                v-if="errors.has('Nama Penanggung Jawab')"
              >
                {{ errors.first('Nama Penanggung Jawab') }}
              </span>
            </div>
            <div class="col-md-6 mb-3">
              <label for="jabatan_penanggungjawab">
                Jabatan Penanggung Jawab <span class="text-danger">*</span>
              </label>
              <b-form-input
                id="jabatan_penanggungjawab"
                v-model="form.jabatan_penanggungjawab"
                v-validate="'required'"
                name="Jabatan Penanggung Jawab"
                :style="{ opacity: isViewOnly ? 0.7 : 1 }"
                :disabled="isViewOnly"
              ></b-form-input>
              <span
                class="text-danger"
                v-if="errors.has('Jabatan Penanggung Jawab')"
              >
                {{ errors.first('Jabatan Penanggung Jawab') }}
              </span>
            </div>
            <div class="col-md-6 mb-3">
              <label for="no_telepon_penanggungjawab">
                Nomor Telepon Seluler <span class="text-danger">*</span>
              </label>
              <b-form-input
                id="no_telepon_penanggungjawab"
                v-model="form.no_telepon_penanggungjawab"
                v-validate="'required'"
                name="Nomor Telepon Seluler"
                :style="{ opacity: isViewOnly ? 0.7 : 1 }"
                :disabled="isViewOnly"
              ></b-form-input>
              <span
                class="text-danger"
                v-if="errors.has('Nomor Telepon Seluler')"
              >
                {{ errors.first('Nomor Telepon Seluler') }}
              </span>
            </div>
          </div>
          <div v-if="catatanPerbaikan" class="row g-0 border-top mt-4 pt-2">
            <div class="col-12">
              <label class="fw-bold">Catatan Perbaikan</label>
              <div
                class="p-2 d-block w-100"
                style="
                  border: 1px #999999 solid;
                  border-radius: 5px;
                  background: #0c2236;
                  color: white;
                "
              >
                <div v-html="catatanPerbaikan"></div>
              </div>
            </div>
          </div>

          <div class="d-flex justify-content-between mt-4">
            <b-button
              variant="danger"
              class="text-white m-1"
              @click="$router.push('/app/pemutakhiran')"
            >
              Kembali
            </b-button>
            <template v-if="!isViewOnly">
              <b-button
                v-if="!statusPemutakhiran"
                variant="primary"
                class="text-white m-1"
                @click="submitForm()"
              >
                Submit
              </b-button>
              <b-button
                v-if="statusPemutakhiran === 'Ditolak'"
                variant="primary"
                class="text-white m-1"
                @click="submitForm()"
              >
                Submit Perbaikan
              </b-button>
            </template>
          </div>
        </b-form>
      </div>
    </Widget>
  </div>
</template>

<script>
import Widget from '@/components/Widget/Widget.vue'
import { Validator } from 'vee-validate'
import vSelect from 'vue-select'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import Swal from 'sweetalert2'
import axios from 'axios'
import { formatDate } from '../../../helper/helpernew'

export default {
  components: { Widget, vSelect },
  data() {
    return {
      baseapi: localStorage.getItem('baseapi'),
      user: JSON.parse(localStorage.getItem('user')),
      wygEditor: ClassicEditor,
      form: {
        file_permohonan_pemuktahiran: null,
        nomor_surat_permohonan: '',
        perihal_surat_permohonan: '',
        tanggal_surat_permohonan: '',
        jenis_pemuktahiran: '',
        jenis_permohonan_perubahan: '',
        jenis_permohonan: '',
        nomor_izin_terbit: '',
        instansi_pemohon: '',
        nib: '',
        npwp: '',
        nomor_permohonan: '',
        tanggal_penerbitan_izin: '',
        alasan_pemuktahiran: '',
        file_dokumen_pendukung: null,
        nama_penanggungjawab: '',
        jabatan_penanggungjawab: '',
        no_telepon_penanggungjawab: '',
      },
      tmpFile: {
        file_permohonan_pemuktahiran: null,
        file_dokumen_pendukung: null,
      },
      statusPemutakhiran: null,
      catatanPerbaikan: null,
      isViewOnly: false,
      showOptionKkprl: false,
      dataPerizinan: [],
      dataNomorKkprl: [],
    }
  },
  methods: {
    async loadData() {
      const id = this.$route.query.id_pemutakhiran
      if (!id) return

      const res = await axios.get(
        `${this.baseapi}api/pemuktahiran/${id}`,
        this.getApiOption(),
      )
      const resData = res.data.data
      for (const k in this.form) {
        if (k.includes('file_')) {
          this.tmpFile[k] = resData[k]
        } else {
          this.form[k] = resData[k]
        }
      }
      this.statusPemutakhiran = resData.status
      this.catatanPerbaikan = resData.catatan_penolakan_pemuktahiran
      this.isViewOnly = resData.status === 'Diterima'
    },

    async submitForm() {
      // prettier-ignore
      {
        this.manualValidation(this.form.alasan_pemuktahiran, 'Alasan Pemutakhiran')
      }
      await this.$validator.validateAll()
      if (this.$validator.errors.items.length) {
        Swal.fire('', 'Mohon lengkapi semua kolom', 'warning')
        return
      }

      const confirm = await Swal.fire({
        title: 'Submit Pemutakhiran?',
        text: 'Tindakan ini tidak bisa dibatalkan atau dihapus',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ya, lanjutkan',
        cancelButtonText: 'Batal',
      })
      if (!confirm.isConfirmed) return

      this.$loading(true)
      const formData = new FormData()
      for (const k in this.form) {
        if (this.form[k]) formData.append(k, this.form[k])
      }
      formData.append('status', 'Menunggu Verifikasi')

      const id = this.$route.query.id_pemutakhiran
      try {
        const apiCheck =
          this.form.jenis_permohonan === 'Berusaha'
            ? `${this.baseapi}api/permohonan/dataTable?filter=nomor_oss,=,${this.form.nomor_izin_terbit}`
            : `${this.baseapi}api/permohonan_nonberusaha/dataTable?filter=nomor_kkp,=,${this.form.nomor_izin_terbit}`
        const resCheck = (await axios.get(apiCheck, this.getApiOption())).data
          .data
        if (!resCheck[0]) {
          Swal.fire(
            'Permohonan tidak ditemukan',
            'Mohon periksa kembali Jenis Permohonan dan Nomor Penerbitan Izin',
            'warning',
          )
          return
        }

        if (!id) {
          await axios.post(
            `${this.baseapi}api/pemuktahiran`,
            formData,
            this.getApiOption(),
          )
        } else {
          await axios.post(
            `${this.baseapi}api/pemuktahiran/${id}`,
            formData,
            this.getApiOption(),
          )
        }
        Swal.fire(
          'Berhasil',
          id
            ? 'Berhasil memperbarui permohonan pemutakhiran'
            : 'Berhasil membuat permohonan pemutakhiran',
          'success',
        )
        if (!id) {
          this.$router.push('/app/pemutakhiran')
        } else {
          this.loadData()
        }
      } catch (error) {
        Swal.fire(
          'Gagal',
          id
            ? 'Gagal memperbarui permohonan pemutakhiran'
            : 'Gagal membuat permohonan pemutakhiran',
          'error',
        )
      } finally {
        this.$loading(false)
      }
    },

    selectJenisKegiatan() {
      this.form = {
        ...this.form,
        nomor_izin_terbit: '',
        instansi_pemohon: '',
        nib: '',
        npwp: '',
        nomor_permohonan: '',
        tanggal_penerbitan_izin: '',
        nama_penanggungjawab: '',
        jabatan_penanggungjawab: '',
        no_telepon_penanggungjawab: '',
      }
      this.getPermohonan()
    },

    async getPermohonan() {
      this.$loading(true)
      if (this.form.jenis_permohonan === 'Berusaha') {
        await axios
          .get(
            this.baseapi +
              `api/permohonan?filter=npwp_pemohon,=,${this.user.npwp};nomor_oss,!=,null`,
            this.getApiOption(),
          )
          .then((res) => {
            const data = res.data.data
            this.dataPerizinan = data
            this.dataNomorKkprl = data.length
              ? data.map((d) => d.nomor_oss)
              : ['Tidak ada pilihan Nomor Penerbitan Izin']
          })
      } else {
        await axios
          .get(
            this.baseapi +
              `api/permohonan_nonberusaha?filter=npwp_pemohon,=,${this.user.npwp};nomor_kkp,!=,null`,
            this.getApiOption(),
          )
          .then((res) => {
            const data = res.data.data
            this.dataPerizinan = data
            this.dataNomorKkprl = data.length
              ? data.map((d) => d.nomor_kkp)
              : ['Tidak ada pilihan Nomor Penerbitan Izin']
          })
      }
      this.$loading(false)
    },

    selectKkprl(d) {
      this.form.nomor_izin_terbit = d

      if (this.form.jenis_permohonan === 'Berusaha') {
        const data = this.dataPerizinan.find((dd) => dd.nomor_oss === d)
        if (data) {
          this.form = {
            ...this.form,
            instansi_pemohon: data.nama_pemohon,
            nib: data.nib_pemohon,
            npwp: data.npwp_pemohon,
            nomor_permohonan: data.nomor_permohonan,
            tanggal_penerbitan_izin: data.tanggal_terbit_oss
              ? formatDate(data.tanggal_terbit_oss, 'YYYY-MM-DD')
              : '',
          }
        }
      } else {
        const data = this.dataPerizinan.find((dd) => dd.nomor_kkp === d)
        if (data) {
          this.form = {
            ...this.form,
            instansi_pemohon: data.instansi_pemohon,
            npwp: data.npwp_pemohon,
            nomor_permohonan: data.nomor_permohonan,
            tanggal_penerbitan_izin: data.tanggal_ttd_mkp
              ? formatDate(data.tanggal_ttd_mkp, 'YYYY-MM-DD')
              : '',
          }
        }
      }

      this.toggleOptionKkprl(false)
    },

    toggleOptionKkprl(val) {
      this.showOptionKkprl = val
    },

    manualValidation(field, name) {
      if (!field) {
        this.$validator.errors.add({
          field: name,
          msg: `${name} wajib diisi`,
        })
        return false
      } else {
        return true
      }
    },

    manualRemoveError(name) {
      this.$validator.errors.remove(name)
    },

    getApiOption() {
      return {
        headers: {
          Authorization: `Bearer ` + this.user.accessToken,
        },
      }
    },

    handleClickOutside(e) {
      const dropdown = this.$refs.dropdownNomorKkprl
      if (!dropdown) return
      if (!dropdown.contains(e.target)) {
        this.toggleOptionKkprl(false)
      }
    },
  },
  computed: {
    filteredNomorKkprl() {
      const filtered = this.dataNomorKkprl.filter((d) =>
        d.includes(this.form.nomor_izin_terbit),
      )
      if (!this.form.jenis_permohonan) {
        return ['Pilih Jenis Permohonan terlebih dahulu']
      }
      return filtered.length
        ? filtered
        : ['Tidak ada pilihan Nomor Penerbitan Izin']
    },
  },
  watch: {
    'form.alasan_pemuktahiran'() {
      this.manualRemoveError('Alasan Pemutakhiran')
    },
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside)

    this.loadData()
    const dictionary = {
      id: {
        messages: {
          required: (fieldName) => `${fieldName} wajib diisi`,
        },
      },
    }
    Validator.localize(dictionary)
    this.$validator.localize('id')
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside)
  },
}
</script>

<style scope>
.option-kkprl-container {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  background: white;
  z-index: 10;
  border-radius: 5px;
  border: 1px solid #aaaaaa;
  overflow-y: auto;
  scrollbar-width: thin;
  max-height: 200px;
}

.option-kkprl-item {
  cursor: pointer;
  padding: 5px 10px;
}

.option-kkprl-item:hover {
  background: #dddddd;
}
</style>
